import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelListChannelDial = styled.span<{
  size: number;
}>`
  color: ${Colors['text']};
  display: inline-block;
  font-family: ${Fonts['regular']};
  font-size: ${(props) => props.size * Screen.widthRatio}px;
  line-height: ${48 * Screen.widthRatio}px;
  margin-right: ${36 * Screen.widthRatio}px;
  text-align: end;
  vertical-align: top;
  width: ${80 * Screen.widthRatio}px;
`;

export default ChannelListChannelDial;
